import { Box } from '@mui/material';
import { ComponentStyle } from '../../../interfaces/Settings/SettingsV2/ComponentStyle';
import { Brand } from '../../../interfaces/Brand/Brand';
import { EditableStyleWrapper } from '../StyleEditor/EditableStyleWrapper';

export const brandLogoWidth = 180;
export const brandLogoHeight = 100;

export type BrandLogoProps = {
  brand: Brand;
  styleOverride?: ComponentStyle;
  stylePath: string;
};

export const BrandLogo = ({
  brand,
  styleOverride,
  stylePath,
}: BrandLogoProps) => {
  return (
    <EditableStyleWrapper path={stylePath}>
      <Box
        sx={{
          width: brandLogoWidth,
          boxSizing: 'border-box',
          px: 10,
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          cursor: 'pointer',
          ...styleOverride,
        }}
      >
        <Box
          component='img'
          src={brand.logo}
          alt={brand.name}
          width={brandLogoWidth - 20}
          height={brandLogoHeight}
          sx={{
            objectFit: 'contain',
          }}
        />
      </Box>
    </EditableStyleWrapper>
  );
};
